import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import { Button, Card, List, Modal } from "antd";
import { EyeOutlined, LeftOutlined, LockOutlined } from "@ant-design/icons";


const ViewProfileAdmin = () => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const moment = require("moment");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = useState(null);
  const userData = useSelector(({ auth }) => auth?.userData);

  const getUserCall = async (id) => {
    dispatch(fetchStart());
    const userResponse = await axiosInstance.get(
      `${BASE_API_CONFIG.baseURL}/users/${id}`
    );
    setSelectedData(userResponse.data.data);
    dispatch(fetchSuccess());
  };
  useEffect(() => {
    if (isValidString(id)) {
      getUserCall(id);
    }
  }, []);

  const ContactInfo = ({ value, label, isSubscribed }) => {
    const [showSubscribeModal, setShowSubscribeModal] = useState(false);
    const isFreightForwarder =
      userData?.businessTypes?.code === "freight_forwarder" ||
      userData?.businessTypes?.code === "exporter" ||
      userData?.businessTypes?.code === "manufacturer" ||
      userData?.businessTypes?.code === "commission_agent" ||
      userData?.businessTypes?.code === "custom_house_agent" ||
      userData?.businessTypes?.code === "shipping_line" ||
      userData?.businessTypes?.code === "manufacturer_exporter";
    const handleClick = () => {
      if (isFreightForwarder && !isSubscribed) {
        setShowSubscribeModal(true);
      }
    };

    return (
      <>
        <div
          onClick={handleClick}
          style={{
            cursor: isFreightForwarder && !isSubscribed ? "pointer" : "default",
            position: "relative",
            display: "inline-block",
          }}
        >
          <div
            style={{
              filter:
                isFreightForwarder && !isSubscribed ? "blur(4px)" : "none",
              position: "relative",
              display: "inline-block",
              transition: "filter 0.3s ease",
              userSelect: isFreightForwarder && !isSubscribed ? "none" : "auto",
            }}
          >
            {value || "-"}
          </div>
        </div>

        {isFreightForwarder && !isSubscribed && (
          <div className="subscribe-overlay">
            <Button
              type="primary"
              size="small"
              className="subscribe-button"
              onClick={handleClick}
              style={{
                marginTop: 8,
                borderRadius: 4,
                fontWeight: 500,
              }}
            >
              <EyeOutlined /> Upgrade to View
            </Button>
          </div>
        )}

        <Modal
          title={<span style={{ fontWeight: 500 }}>Upgrade Required</span>}
          visible={showSubscribeModal}
          onCancel={() => setShowSubscribeModal(false)}
          footer={null}
          centered
          width={380}
          bodyStyle={{ padding: "24px" }}
        >
          <div style={{ textAlign: "center" }}>
            <LockOutlined
              style={{ fontSize: 32, color: "#1890ff", marginBottom: 16 }}
            />
            <h3 style={{ marginBottom: 8, fontWeight: 500 }}>
              Upgrade Your Plan
            </h3>
            <p style={{ color: "rgba(0, 0, 0, 0.65)", marginBottom: 24 }}>
              To view this {label}, please upgrade your subscription plan.
            </p>
            <Button
              type="primary"
              block
              onClick={() => {
                history.push("/subscription-User");
                setShowSubscribeModal(false);
              }}
              style={{
                height: 40,
                fontWeight: 500,
              }}
            >
              View Subscription Plans
            </Button>
          </div>
        </Modal>
      </>
    );
  };
  
  const data = [
    {
      label: "Joined on",
      value: isValidString(selectedData?.createdAt)
        ? moment(selectedData?.createdAt).format("DD-MMM-YYYY")
        : "-",
    },
    {
      label: "Location",
      value: `${isValidString(selectedData?.city) ? selectedData?.city : ""}${
        isValidString(selectedData?.city) ? "," : ""
      } ${isValidString(selectedData?.country) ? selectedData?.country : "-"}`,
    },
    {
      label: "Email",
      value: (
        <ContactInfo
          value={selectedData?.email}
          label="email"
        />
      ),
    },
    {
      label: "Phone Number",
      value: (
        <ContactInfo
          value={selectedData?.mobile}
          label="phone number"
        />
      ),
    },
    {
      label: "Company Name",
      value: isValidString(selectedData?.companyName)
        ? selectedData.companyName
        : "-",
    },
    {
      label: "About Company",
      value: isValidString(selectedData?.companyDescription)
        ? selectedData.companyDescription
        : "-",
    },
  ];
  return (
    isValidElement(selectedData) && (
      <>
        <Card className="myexim-detail-card" style={{ width: "100%" }}>
          <div className="myexim-table-title">
            <LeftOutlined
              className={"back-icon"}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
            User Profile
          </div>
          <div
            className={`logo-with-list gx-mt-4 ${
              isMobile ? "gx-flex-column" : ""
            }`}
          >
            <div style={{ paddingRight: 16 }}>
              {isValidString(selectedData?.companyLogo) && (
                <div className={"logo-container"}>
                  <div className={"logo-image"}>
                    <img
                      alt="..."
                      src={selectedData?.companyLogo}
                      width={isMobile ? "100%" : 120}
                      height={isMobile ? "100%" : 120}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item) =>
                  item?.value && (
                    <List.Item className="myexim-details-list">
                      <List.Item.Meta
                        title={<div>{item.label}</div>}
                        description={item.value}
                      />
                    </List.Item>
                  )
                }
              />
            </div>
          </div>
        </Card>
      </>
    )
  );
};

export default ViewProfileAdmin;
